import { render } from "./Befreundet.vue?vue&type=template&id=0de3b178"
import script from "./Befreundet.vue?vue&type=script&lang=js"
export * from "./Befreundet.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__